import { ActionTypes } from '../constants/index';

export const eventDetails = (payload: any) => ({
  type: ActionTypes.EVENT_DETAIL_LIST_REQUEST,
  payload,
});
